import { useGraphQL } from 'graphql-react';
import { versoFetchOptionsOverride } from '../lib/graphql';

export const useVersoAPI = options => {
  return useGraphQL({
    fetchOptionsOverride: versoFetchOptionsOverride,
    ...options,
  });
};
